import type { DBTypes } from '@openphone/dexie-database/types'
import uuid from '@openphone/lib/uuid'
import { makeAutoObservable, toJS } from 'mobx'
import type { MarkOptional } from 'ts-essentials'

/* eslint-disable-next-line import-x/no-restricted-paths -- FIXME: UXP-4500 */
import type { StepDefinitionId } from '@src/app/components/workflow/types'
import type { Model } from '@src/service/model/base'

export type RawWorkflowStepDefinition = DBTypes.WorkflowStepDefinitionRow

export default class WorkflowStepDefinitionModel implements Model {
  private raw: RawWorkflowStepDefinition

  get id() {
    return this.raw.id
  }

  get requiredConfiguration() {
    return this.raw.requiredConfiguration
  }

  get canComeAfterTrigger() {
    return this.raw.canComeAfterTrigger
  }

  get categoryMustMatchTrigger() {
    return this.raw.categoryMustMatchTrigger
  }

  get requiredCapabilities() {
    return this.raw.requiredCapabilities
  }

  get canNotComeAnywhereAfterSteps() {
    return this.raw.canNotComeAnywhereAfterSteps
  }

  get terminalFor() {
    return this.raw.terminalFor
  }

  get category() {
    return this.raw.category
  }

  get outputBranches() {
    return this.raw.outputBranches
  }

  get defaultOrFirstOutputBranch() {
    return (
      this.outputBranches?.find((branch) => branch.isDefault) ?? this.outputBranches?.[0]
    )
  }

  get supportLevel() {
    return this.raw.supportLevel
  }

  get allowsReentry() {
    return this.raw.allowsReentry
  }

  get maxInstancesInPath() {
    return this.raw.maxInstancesInPath
  }

  get version() {
    return this.raw.version
  }

  constructor(attrs: MarkOptional<RawWorkflowStepDefinition, 'id'>) {
    this.raw = {
      ...attrs,
      id: (attrs.id as StepDefinitionId) ?? `WSD${uuid()}`.replace(/-/g, ''),
    }

    makeAutoObservable<this>(this)
  }

  deserialize(json: RawWorkflowStepDefinition): this {
    this.raw = json
    return this
  }

  serialize(): RawWorkflowStepDefinition {
    return toJS(this.raw)
  }

  localUpdate(attrs: Partial<RawWorkflowStepDefinition>): this {
    this.raw = { ...this.raw, ...attrs }
    return this
  }
}
